import React, { ReactElement } from 'react';
import { SelectablePeriodTemplateState } from 'adapter/in/common/components/PeriodSelector';
import { useBranding } from 'adapter/in/common/context/static/Branding';
import { useProfile } from 'adapter/in/common/context/static/Profile';
import { FormPeriodSelector, onChangePeriodSelector } from 'adapter/in/common/form/PeriodSelector';
import { SelectorContainerProps } from 'adapter/in/common/form/Selector';
import { FieldStatus, SelectorType } from 'adapter/in/common/form/types';
import { useBaseDefaultValuesSelector } from 'adapter/in/common/hooks/form/useBaseDefaultValuesSelector';
import { useBaseSelectorContainer } from 'adapter/in/common/hooks/form/useBaseSelectorContainer';
import PresetFormFieldProperties from 'domain/entity/preset/form/presetFormFieldProperties';

type PeriodSelectorContainerProps = SelectorContainerProps & {
    properties: PresetFormFieldProperties;
    style?: React.CSSProperties;
    hasContext?: boolean;
};

export const DefaultValuesPeriodSelectorContainer = ({
    name,
    affectsTo,
    dataDependsOn,
    properties,
    label,
    configType,
    disabled,
    style,
    hasContext,
}: PeriodSelectorContainerProps): ReactElement => {
    const { branding } = useBranding();
    const { profile } = useProfile();
    const { value, onChange, shouldLoad } = useBaseSelectorContainer(name, {}, undefined, dataDependsOn, affectsTo);
    const defaultValues = properties?.defaultValues ? properties?.defaultValues : [];
    const { options } = useBaseDefaultValuesSelector<SelectablePeriodTemplateState>(
        SelectorType.PERIOD,
        configType,
        value,
        shouldLoad,
        defaultValues,
        onChange
    );

    return (
        <FormPeriodSelector
            style={style}
            label={label}
            primaryColor={branding.primaryColor}
            onChange={onChangePeriodSelector(onChange, configType)}
            disabled={disabled}
            value={value.status === FieldStatus.HAS_VALUE ? value.value[0].value : undefined}
            options={options}
            dateFormat={profile.dateFormat}
            hasContext={hasContext}
        />
    );
};
